(() => {
  'use strict';

  const aliases = new Map(Object.entries({
    carb:'carburetor',carbs:'carburetor',carby:'carburetor',
    brakes:'brake',pads:'pad',clutches:'clutch',
    plastics:'plastic',bodywork:'plastic',pipe:'exhaust',pipes:'exhaust',silencer:'exhaust',muffler:'exhaust',
    lube:'oil',lubricant:'oil',lubrication:'oil',hoodies:'hoodie',tee:'shirt',tees:'shirt',tshirt:'shirt',tshirts:'shirt',
    bars:'handlebar',handlebars:'handlebar',grips:'grip',levers:'lever',sprockets:'sprocket',chains:'chain',filters:'filter',
    gaskets:'gasket',seals:'seal',bearings:'bearing',jets:'jet',pegs:'footpeg',footpegs:'footpeg',rotors:'rotor',discs:'rotor',
    cylinders:'cylinder',pistons:'piston',cobras:'cobra'
  }));
  const normalizeSearch = raw => String(raw || '')
    .trim()
    .replace(/\btop[ -]?end\b/gi,'piston cylinder')
    .replace(/\bbottom[ -]?end\b/gi,'crankshaft bearing')
    .replace(/\bair[ -]?cleaner\b/gi,'air filter')
    .replace(/\bkill[ -]?switch\b/gi,'stop switch')
    .split(/\s+/)
    .map(token => aliases.get(token.toLowerCase()) || token)
    .join(' ');

  const setupCatalogSearch = form => {
    if (!form || form.dataset.catalogSearchReady === 'true') return;
    form.dataset.catalogSearchReady = 'true';
    const input=form.querySelector('input[type="search"][name="q"]');
    if(!input)return;
    form.addEventListener('submit',event=>{
      const normalized=normalizeSearch(input.value);
      if(!normalized){event.preventDefault();input.focus();return;}
      input.value=normalized;
      if(!form.querySelector('input[name="type"]'))form.insertAdjacentHTML('beforeend','<input type="hidden" name="type" value="product">');
      if(!form.querySelector('input[name="options[prefix]"]'))form.insertAdjacentHTML('beforeend','<input type="hidden" name="options[prefix]" value="last">');
    });
  };

  const setupSearch = form => {
    if (!form || form.dataset.searchToggleReady === 'true') return;
    form.dataset.searchToggleReady = 'true';
    const input = form.querySelector('input[type="search"]');
    const button = form.querySelector('button[type="submit"]');
    if (!input || !button) return;

    const open = () => {
      form.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-label', 'Search the store');
      window.setTimeout(() => input.focus(), 80);
    };
    const close = () => {
      if (input.value.trim()) return;
      form.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', 'Open store search');
    };

    button.addEventListener('click', event => {
      if (!form.classList.contains('is-open')) {
        event.preventDefault();
        open();
      }
    });
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        input.value = '';
        close();
        button.focus();
      }
    });
    document.addEventListener('pointerdown', event => {
      if (!form.contains(event.target)) close();
    });
  };

  document.querySelectorAll('.global-search.search-collapsible').forEach(setupSearch);
  document.querySelectorAll('form.global-search, form.store-search-form').forEach(setupCatalogSearch);

  const showProductImage = button => {
    const root = button.closest('[data-product-gallery]');
    if (!root) return;
    const main = root.querySelector('[data-product-main]');
    if (main) main.src = button.dataset.image;
    const buttons = root.querySelectorAll('[data-product-thumb]');
    buttons.forEach(item => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    const count = root.querySelector('.mi-product-image-count');
    if (count) count.textContent = button.dataset.index + ' / ' + buttons.length;
  };

  const setupProductGalleries = () => {
    document.querySelectorAll('[data-product-thumb]').forEach(button => {
      if (button.dataset.galleryReady === 'true') return;
      button.dataset.galleryReady = 'true';
      button.addEventListener('pointerdown', () => showProductImage(button));
      button.addEventListener('click', () => showProductImage(button));
      button.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') showProductImage(button);
      });
    });
  };

  setupProductGalleries();
  document.addEventListener('shopify:section:load', setupProductGalleries);

  document.querySelectorAll('[data-site-back]').forEach(link => {
    link.addEventListener('click', event => {
      if (!document.referrer) return;
      let previous;
      try { previous = new URL(document.referrer); } catch { return; }
      if (previous.origin !== location.origin) return;
      event.preventDefault();
      history.back();
    });
  });

  const setupProductForms = () => {
    document.querySelectorAll('.pnw-product-form').forEach(form => {
      if (form.dataset.variantReady === 'true') return;
      form.dataset.variantReady = 'true';
      const select = form.querySelector('[data-product-variant]');
      if (!select) return;
      const root = form.closest('.pnw-product-info');
      const price = root && root.querySelector('[data-product-price]');
      const sku = root && root.querySelector('[data-product-sku]');
      const submit = form.querySelector('[data-product-submit]');

      const applyVariant = () => {
        const option = select.options[select.selectedIndex];
        if (!option) return;
        if (price) price.textContent = option.dataset.price || '';
        if (sku) sku.textContent = option.dataset.sku || '';
        const available = option.dataset.available === 'true';
        if (submit) {
          submit.disabled = !available;
          submit.textContent = available ? 'Add to cart' : 'Sold out';
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      };

      select.addEventListener('change', applyVariant);
      applyVariant();
    });
  };

  setupProductForms();
  document.addEventListener('shopify:section:load', setupProductForms);
})();


/* Money Inc product-image placeholder replacement */
(() => {
  'use strict';
  const placeholder = 'https://cdn.shopify.com/s/files/1/0910/5355/5985/files/moneyinc-product-placeholder.png?v=1790956788';
  const cobraPlaceholder = /(cobra[-_ ]*moto[-_ ]*elite[-_ ]*dealer[-_ ]*logo|cobra[-_ ]*elite[-_ ]*dealer|cobralogo)/i;
  const apply = (root = document) => {
    const images = root instanceof HTMLImageElement ? [root] : (root.querySelectorAll ? root.querySelectorAll('img') : []);
    images.forEach(img => {
      if (img.classList.contains('mi-hero-dealer-logo')) return;
      const source = decodeURIComponent(img.currentSrc || img.getAttribute('src') || '');
      if (!cobraPlaceholder.test(source)) return;
      if (!img.closest('.store-main-image, [data-product-gallery], .product__media, .product-media, .product__media-wrapper, [data-product-main-image], .mi-product-main-image, a[href*="/products/"], .collection-product-card, .store-card, .product-card, .card__media')) return;

      const picture = img.closest('picture');
      if (picture) picture.querySelectorAll('source').forEach(source => {
        source.removeAttribute('srcset');
        source.removeAttribute('sizes');
      });
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = placeholder;
      img.alt = 'Product image unavailable';
      img.classList.add('moneyinc-product-placeholder');
    });
  };
  const start = () => {
    apply();
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'attributes') apply(record.target);
        record.addedNodes.forEach(node => {
          if (node.nodeType === 1) apply(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();


/* Money Inc fallback for products with no image */
(() => {
  'use strict';
  const placeholder = 'https://cdn.shopify.com/s/files/1/0910/5355/5985/files/moneyinc-product-placeholder.png?v=1790956788';
  const fillMissing = (root = document) => {
    const selectors = [
      '.store-main-image',
      '.collection-product-card .store-card-image',
      '.store-card .store-card-image',
      '.product-card__media',
      '[data-product-gallery] [data-product-main-container]'
    ];
    root.querySelectorAll(selectors.join(',')).forEach(box => {
      if (box.querySelector('img')) return;
      const link = box.closest('a[href*="/products/"]') || box.querySelector('a[href*="/products/"]');
      if (!link && !box.classList.contains('store-main-image') && !box.closest('[data-product-gallery]')) return;
      const img = document.createElement('img');
      img.src = placeholder;
      img.alt = 'Product image unavailable';
      img.loading = box.classList.contains('store-main-image') ? 'eager' : 'lazy';
      img.className = 'moneyinc-product-placeholder';
      box.appendChild(img);
    });
  };
  const start = () => {
    fillMissing();
    new MutationObserver(() => fillMissing()).observe(document.documentElement, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
